import styled from 'styled-components';
import { Upload } from 'antd';

export const UploadDragger = styled(Upload.Dragger)`
  background: ${({ theme }) => theme.colors.background} !important;
  border-color: ${({ theme }) => theme.colors.primary} !important;
`;

export const DraggerContent = styled.div`
  padding: 8px 16px;

  .ant-upload-text {
    color: ${({ theme }) => theme.colors.text1} !important;
    margin-bottom: 8px !important;
  }

  .ant-upload-hint {
    color: ${({ theme }) => theme.colors.text2} !important;
    font-size: 0.8rem !important;
  }
`;
